import { render } from "./ColumnVisibilityMatrix.vue?vue&type=template&id=6514f7e4"
import script from "./ColumnVisibilityMatrix.vue?vue&type=script&lang=js"
export * from "./ColumnVisibilityMatrix.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__